// extracted by mini-css-extract-plugin
export default {"root_image_inner":"sizeForm_root_image_inner__3uV1C"};